import type { AppDispatch } from "../../../app/store";
import { ROUTES } from "../../../routes";
import { PENDING_INVITE_TOKEN_KEY } from "../../organization/pendingInviteToken";
import { ContextKind } from "../enums/ContextKind";
import { fetchContexts, openMemberContext } from "../slice-extensions/contexts-slice-extension";

/**
 * Where an instructor-side sign-in (password, magic link, code, Google, Apple, Microsoft) lands: a
 * pending invitation first; a deep link next (it was heading into the signed-in context); then the
 * chooser when the person has more than one context; the portal when the one context is a member row
 * (a member-only sign-in, US-113); else `target` as before.
 */
export const resolvePathAfterSignIn = async (
  dispatch: AppDispatch,
  target: string = ROUTES.HOME,
): Promise<string> => {
  const pendingInviteToken = localStorage.getItem(PENDING_INVITE_TOKEN_KEY);
  if (pendingInviteToken) {
    return `${ROUTES.INVITATION}?token=${encodeURIComponent(pendingInviteToken)}`;
  }
  if (target !== ROUTES.HOME) return target;

  const result = await dispatch(fetchContexts());
  if (!fetchContexts.fulfilled.match(result)) return target;
  const { contexts } = result.payload;
  if (contexts.length > 1) return ROUTES.CHOOSE_CONTEXT;

  const only = contexts[0];
  if (only?.kind !== ContextKind.Member || !only.memberId) return target;
  const opened = await dispatch(openMemberContext(only));
  return openMemberContext.fulfilled.match(opened)
    ? `${ROUTES.PORTAL}?member=${encodeURIComponent(only.memberId)}`
    : target;
};
